import React from "react";
import { getPhotoUrl } from "../../helpers";
import cn from "classnames";

import { chatConstants } from "../../constants/chat";
import styles from "./styles.module.scss";

const customText = {
  [chatConstants.STICKER]: "Sent sticker",
  [chatConstants.DISAPPEAPING_PHOTO]: "Sent disappearing photo",
  [chatConstants.DISAPPEAPING_VIDEO]: "Sent disappearing video",
};

function Message({ msg }) {
  return (
    <div className={styles.messageWrap}>
      <div className={styles.avatar}>
        {!msg.user.avatar.empty && (
          <div
            style={{
              backgroundImage:
                'url("' + getPhotoUrl(msg.user.avatar.thumbnail) + '")',
            }}
          />
        )}
      </div>
      <div className={styles.message}>
        <p className={styles.name}>{msg.user.username}</p>
        <p
          className={cn(styles.text, {
            [styles[msg.action]]: msg.action,
          })}
        >
          {[
            chatConstants.STICKER,
            chatConstants.DISAPPEAPING_PHOTO,
            chatConstants.DISAPPEAPING_VIDEO,
          ].includes(msg.message.type)
            ? customText[msg.message.type]
            : msg.message.body}
        </p>
      </div>
    </div>
  );
}

export default Message;
